{
  "inputs": {
    "content": {
      "placeholder": "Write a new post..."
    },
    "hyperlinkURL": {
      "placeholder": "Enter link"
    },
    "hyperlinkText": {
      "placeholder": "Learn More"
    },
    "videoURL": {
      "placeholder": "Enter video link"
    }
  },
  "buttons": {
    "confirm": {
      "text": "Publish",
      "loadingText": "Publishing"
    },
    "audiencePicker": {
      "everyone": "Everyone",
      "allYears": "All Years",
      "custom": "Custom Audience",
      "hint": "Choose an audience to publish."
    }
  },
  "banner": {
    "micropostStaff": "All active Staff will be able to view microposts even if Audience Segments are applied."
  }
}
